document.addEventListener("DOMContentLoaded", async () => {

    let userId = devtricker_getTheUserId();
    let tagId = parseInt(document.getElementById('tagData')?.getAttribute('data-tag-id') || 0, 10);

    let element = document.getElementById("recommend-tags");
    if(element){

        let content = await devtricker_ajax_get_suggestedTags(userId, tagId);

        let currentAside = element.querySelector('aside');
        currentAside.remove();
        element.appendChild(content);
    }
});